import { render, staticRenderFns } from "./LoadCaseTable.vue?vue&type=template&id=eda3cc98"
import script from "./LoadCaseTable.vue?vue&type=script&lang=ts"
export * from "./LoadCaseTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eda3cc98')) {
      api.createRecord('eda3cc98', component.options)
    } else {
      api.reload('eda3cc98', component.options)
    }
    module.hot.accept("./LoadCaseTable.vue?vue&type=template&id=eda3cc98", function () {
      api.rerender('eda3cc98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Viewer/Info/LoadCaseTable.vue"
export default component.exports